import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { SiIconComponent } from '@siemens/element-ng/icon';
import { ThemeService } from '../../services/theme.service';

@Component({
    selector: 'app-theme-toggle',
    templateUrl: './theme-toggle.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SiIconComponent]
})
export class ThemeToggleComponent {
    private readonly themeService = inject(ThemeService);

    protected readonly isDarkMode = computed(() => this.themeService.isDarkMode());
    protected readonly icon = computed(() => (this.isDarkMode() ? 'element-sun' : 'element-economy'));
    protected readonly ariaLabel = computed(() => (this.isDarkMode() ? 'Switch to light mode' : 'Switch to dark mode'));

    protected toggleTheme(): void {
        this.themeService.toggleTheme();
    }
}
